import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export interface LibraryImage { id: string; file_id: string; url: string; name: string; tags: string[]; added_by: string; added_by_name?: string; created_at: string }

export const parseTags = (s: string) => s.split(/[,;]/).map((t) => t.trim().toLowerCase()).filter(Boolean);

export function useLibraryImages(enabled = true) {
  const [images, setImages] = useState<LibraryImage[]>([]);
  const [tags, setTags] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const reload = useCallback(async () => {
    setLoading(true);
    try { const [a, b] = await Promise.all([api.get("/library-images"), api.get("/library-images/tags")]); setImages(a.data); setTags(b.data); }
    catch (e) { toast.error(errMsg(e)); } finally { setLoading(false); }
  }, []);
  useEffect(() => { if (enabled) reload(); }, [enabled, reload]);
  return { images, tags, loading, reload };
}

export async function uploadLibraryImages(files: File[], tags: string[] = []) {
  let ok = 0;
  for (const f of files) {
    const fd = new FormData(); fd.append("file", f); fd.append("tags", tags.join(","));
    try { await api.post("/library-images/upload", fd); ok++; } catch (e) { toast.error(`${f.name}: ${errMsg(e)}`); }
  }
  if (ok) toast.success(`${ok} image${ok > 1 ? "s" : ""} added to the library`);
  return ok;
}

export const filterImages = (images: LibraryImage[], q: string, tag: string | null) => {
  const s = q.trim().toLowerCase();
  return images.filter((i) => (!tag || i.tags.includes(tag)) && (!s || i.name.toLowerCase().includes(s) || i.tags.some((t) => t.includes(s))));
};
